import { isEmpty } from 'lodash';

export const transformDetails = poa => {
  if (isEmpty(poa)) return {};

  return {
    userId: poa?.userId || poa?.id,
    eid: poa?.eid,
    nameEn: poa?.nameEn || poa?.name,
    nameAr: poa?.nameAr,
    nationalityEn: poa?.nationalityEn || poa?.nationalityName,
    nationalityAr: poa?.nationalityAr || poa?.nationalityNameAr,
    phoneNo: poa?.phoneNumber || poa?.phoneNo,
    email: poa?.email,
    representativeType: poa?.representativeType,
    source: poa?.source,
    poaNumber: poa?.poaNumber,
    authorizationDate: poa?.authorizationDate,
  };
};

export default {};
